import React, { useEffect, useRef } from 'react';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { ApplicationEntryLayout } from '../components/ApplicationEntryLayout/ApplicationEntryLayout';
import ValidationGroup from 'devextreme-react/validation-group';
import { useValidateAndSaveApplication } from '../hooks/useValidateAndSaveApplication';
import { OtherAmount as PropertyCostOtherAmount } from './components/PropertyCost/components/OtherAmount';
import { OtherDescription as PropertyCostOtherDescription } from './components/PropertyCost/components/OtherDescription';
import { OtherAmount as SiteWorkFixFlipOtherAmount } from './components/SiteWorkFixFlip/components/OtherAmount';
import { OtherDescription as SiteWorkFixFlipOtherDescription } from './components/SiteWorkFixFlip/components/OtherDescription';
import { OtherAmount as ExteriorStructureOtherAmount } from './components/ExteriorStructure/components/OtherAmount';
import { OtherDescription as ExteriorStructureOtherDescription } from './components/ExteriorStructure/components/OtherDescription';
import { OtherAmount as MajorSystemsOtherAmount } from './components/MajorSystems/components/OtherAmount';
import { OtherDescription as MajorSystemsOtherDescription } from './components/MajorSystems/components/OtherDescription';
import { OtherAmount as InteriorOtherAmount } from './components/Interior/components/OtherAmount';
import { OtherDescription as InteriorOtherDescription } from './components/Interior/components/OtherDescription';
import { OtherAmount as FinalStructureOtherAmount } from './components/FinalStructure/components/OtherAmount';
import { OtherDescription as FinalStructureOtherDescription } from './components/FinalStructure/components/OtherDescription';
import { Demolition } from './components/SiteWorkFixFlip/components/Demolition';
import { BuildingPermitFees } from './components/SiteWorkFixFlip/components/BuildingPermitFees';
import { ArchitectureEngineering } from './components/SiteWorkFixFlip/components/ArchitectureEngineering';
import { Roofing } from './components/ExteriorStructure/components/Roofing';
import { WindowsAndDoors } from './components/ExteriorStructure/components/WindowsAndDoors';
import { GarageDoor } from './components/ExteriorStructure/components/GarageDoor';
import { Plumbing } from './components/MajorSystems/components/Plumbing';
import { Electrical } from './components/MajorSystems/components/Electrical';
import { HVAC } from './components/MajorSystems/components/HVAC';
import { Insulation } from './components/Interior/components/Insulation';
import { Drywall } from './components/Interior/components/Drywall';
import { Lighting } from './components/Interior/components/Lighting';
import { Appliances } from './components/Interior/components/Appliances';
import { PlumbingFixtures } from './components/Interior/components/PlumbingFixtures';
import { Flooring } from './components/Interior/components/Flooring';
import { Landscaping } from './components/FinalStructure/components/Landscaping';
import { OutdoorStructures } from './components/FinalStructure/components/OutdoorStructures';
import { DrivewayAndWalks } from './components/FinalStructure/components/DrivewayAndWalks';
import { CleanUp } from './components/FinalStructure/components/CleanUp';
import { Button, ButtonTheme, useWaitOverlayStore } from '@apply/components';
import { AcquisitionPrice } from './components/PropertyCost/components/AcquisitionPrice';
import { InitialInspection } from './components/PropertyCost/components/InitialInspection';
import { PaintingSidingWallFinish } from './components/ExteriorStructure/components/PaintingSidingWallFinish';
import { PaintingSidingWallFinishDescription } from './components/ExteriorStructure/components/PaintingSidingWallFinishDescription';
import { DemolitionDescription } from './components/SiteWorkFixFlip/components/DemolitionDescription';
import { BuildingPermitFeesDescription } from './components/SiteWorkFixFlip/components/BuildingPermitFeesDescription';
import { ArchitectureEngineeringDescription } from './components/SiteWorkFixFlip/components/ArchitectureEngineeringDescription';
import { GuttersOrFasciaDownspout } from './components/ExteriorStructure/components/GuttersOrFasciaDownspout';
import { GuttersFasciaDownspoutDescription } from './components/ExteriorStructure/components/GuttersOrFasciaDownspoutDescription';
import { PorchOrDeck } from './components/ExteriorStructure/components/PorchOrDeck';
import { PorchOrDeckDescription } from './components/ExteriorStructure/components/PorchOrDeckDescription';
import { RoofingDescription } from './components/ExteriorStructure/components/RoofingDescription';
import { WindowsAndDoorsDescription } from './components/ExteriorStructure/components/WindowsAndDoorsDescription';
import { GarageDoorDescription } from './components/ExteriorStructure/components/GarageDoorDescription';
import { PlumbingDescription } from './components/MajorSystems/components/PlumbingDescription';
import { ElectricalDescription } from './components/MajorSystems/components/ElectricalDescription';
import { HVACDescription } from './components/MajorSystems/components/HVACDescription';
import { SewerOrSeptic } from './components/MajorSystems/components/SewerOrSeptic';
import { SewerOrSepticDescription } from './components/MajorSystems/components/SewerOrSepticDescription';
import { InsulationDescription } from './components/Interior/components/InsulationDescription';
import { DrywallDescription } from './components/Interior/components/DrywallDescription';
import { InteriorTrimsDoorsAndMirrors } from './components/Interior/components/InteriorTrimsDoorsAndMirrors';
import { InteriorTrimsDoorsAndMirrorsDescription } from './components/Interior/components/InteriorTrimsDoorsAndMirrorsDescription';
import { LightingDescription } from './components/Interior/components/LightingDescription';
import { CabinetsAndCountertops } from './components/Interior/components/CabinetsCountertops';
import { CabinetsAndCountertopsDescription } from './components/Interior/components/CabinetsAndCountertopsDescription';
import { AppliancesDescription } from './components/Interior/components/AppliancesDescription';
import { FlooringDescription } from './components/Interior/components/FlooringDescription';
import { Fireplace } from './components/Interior/components/Fireplace';
import { FireplaceDescription } from './components/Interior/components/FireplaceDescription';
import { Item1 } from './components/ExpandPrimaryStructure/components/Item1';
import { Item1Description } from './components/ExpandPrimaryStructure/components/Item1Description';
import { Item2 } from './components/ExpandPrimaryStructure/components/Item2';
import { Item2Description } from './components/ExpandPrimaryStructure/components/Item2Description';
import { Item3 } from './components/ExpandPrimaryStructure/components/Item3';
import { Item3Description } from './components/ExpandPrimaryStructure/components/Item3Description';
import { Item4 } from './components/ExpandPrimaryStructure/components/Item4';
import { Item4Description } from './components/ExpandPrimaryStructure/components/Item4Description';
import { Item5Description } from './components/ExpandPrimaryStructure/components/Item5Description';
import { Item5 } from './components/ExpandPrimaryStructure/components/Item5';
import { LandscapingDescription } from './components/FinalStructure/components/LandscapingDescription';
import { OutdoorStructuresDescription } from './components/FinalStructure/components/OutdoorStructuresDescription';
import { DrivewayAndWalksDescription } from './components/FinalStructure/components/DrivewayAndWalksDescription';
import { CleanUpDescription } from './components/FinalStructure/components/CleanUpDescription';
import { ApplyApi, IBudgetFixFlip } from '@apply/api/src/api/ApplyApi';
import { applicationInsights } from '../../ApplicationInsights';
import '../scss/_budgetPage.scss';
import Validator, { CustomRule } from 'devextreme-react/validator';
import DxTextBox from 'devextreme-react/text-box';
import ValidationSummary from 'devextreme-react/validation-summary';
import validationEngine from 'devextreme/ui/validation_engine';
import { useSaveApplicationWithoutValidation } from '../hooks/useSaveApplicationWithoutValidation';
import { useRedirectIfComplete } from '../hooks/useRedirectIfApplicationComplete';
import { CurrentApplicationPage, useNavigateApplication } from '../hooks/useNavigateApplication';
import { budgetAndSpecSheetNameBuilder } from '../constants/budgetAndSpecSheetNameBuilder';
import { usePausePointTracker } from '../hooks/usePausePointTracker.tsx';
import { BudgetTotal } from './components/BudgetTotal.tsx';
import { sumBudgetNumbers } from './functions/sumBudgetNumbers.ts';
import { PlumbingFixturesDescription } from './components/Interior/components/PlumbingFixturesDescription.tsx';
import { useApplicationQuery } from '../../queries/applicationQueries';
import { useApplicationPropertyForms } from '../../queries/BorrowerFields/ApplicationFields';
import { usePropertyStreet1, usePropertyStreet2 } from '../../queries/usePropertyCoreFields';
import { usePropertyFixFlipBudgetFile } from '../../queries/PropertyFileFields/NonRentalFiles';
import { useBudgetFixFlipCache } from './queries/useBudgetFixFlipCache';
import { ApplicationCrumbType } from '../components/ApplicationEntryLayout/components/ApplicationEntrySections/types/ApplicationCrumbType.tsx';

interface BudgetFixFlipPageParameters {
    printMode?: boolean;
}

export const BudgetFixFlipPage: React.FC<BudgetFixFlipPageParameters> = ({ printMode = false }) => {
    const { entryGuid } = useParams<{ entryGuid?: string }>();
    const { search } = useLocation();
    const propertyGuid = new URLSearchParams(search).get('pid') || '';

    const token = new URLSearchParams(search).get('token');
    const { isPending } = useApplicationQuery(entryGuid, token);

    const applyApi = new ApplyApi(applicationInsights);
    const BUDGET_GROUP = 'budget-min-total';
    const validationGroupRef = useRef(null);
    const { validateAndSaveApplication } = useValidateAndSaveApplication(validationGroupRef);
    const { saveApplicationNoValidation } = useSaveApplicationWithoutValidation();
    const navigate = useNavigate();
    const budget = useBudgetFixFlipCache(propertyGuid);
    const { handleMode: budgetHandleMode, setSavedFormId } = usePropertyFixFlipBudgetFile(propertyGuid);
    const [propertyName] = usePropertyStreet1(propertyGuid);
    const [propertyName2] = usePropertyStreet2(propertyGuid);
    const [forms, setForms] = useApplicationPropertyForms();
    const { navigateApplicationForward, navigateApplicationBackward } = useNavigateApplication({
        page: CurrentApplicationPage.Budget,
        entryGuid,
        propertyGuid,
    });
    const { updatePausePoint, clearPausePoint } = usePausePointTracker();

    const newFixFlipBudgetSelected = budgetHandleMode === 'createnewform';
    const savedFixFlipBudgetSelected = budgetHandleMode === 'editsavedform';

    useRedirectIfComplete(printMode);

    useEffect(() => {
        if (!isPending) {
            useWaitOverlayStore.getState().setWaiting(false);
        }
    }, [isPending]);

    useEffect(() => {
        if (!entryGuid || savedFixFlipBudgetSelected) return;
        const currentForms = forms ?? [];
        const exists = currentForms.some((f) => f.type === 'Fix-Flip' && f.propertyGuid === propertyGuid);
        if (exists) return;
        const stub: IBudgetFixFlip = {
            id: 0,
            guid: entryGuid,
            type: 'Fix-Flip' as IBudgetFixFlip['type'],
            name: '',
            propertyGuid,
            values: {} as IBudgetFixFlip['values'],
        };
        setForms([...currentForms, stub]);
    }, [entryGuid, savedFixFlipBudgetSelected]);

    useEffect(() => {
        if (!entryGuid) return;
        const currentForms = forms ?? [];
        const fullPN = budgetAndSpecSheetNameBuilder(propertyName ?? '', propertyName2 ?? '');
        const idx = currentForms.findIndex((f) => f.type === 'Fix-Flip' && f.propertyGuid === propertyGuid);
        if (idx === -1) return;
        const newForms = [...currentForms];
        newForms[idx] = { ...newForms[idx], name: fullPN };
        setForms(newForms);
    }, [propertyName, propertyName2]);

    useEffect(() => {
        if (printMode) document.body.style.backgroundColor = '#fff';
    }, [printMode]);

    if (isPending && entryGuid) {
        return null;
    }

    const onSaveAndContinue = async (e: React.MouseEvent<Element, MouseEvent>) => {
        if (e) e.preventDefault();

        clearPausePoint();

        const result = validationEngine.validateGroup(BUDGET_GROUP);
        if (!result?.isValid) return;

        const applicationResponse = await validateAndSaveApplication();
        if (!applicationResponse) return;

        const savedFormResponse = await applyApi.updateSharedForm(budget);
        if (savedFormResponse?.result) setSavedFormId(savedFormResponse.result);

        navigateApplicationForward();
    };

    const onSaveAndExit = async (e: React.MouseEvent<Element, MouseEvent>) => {
        if (e) e.preventDefault();

        updatePausePoint();

        const applicationResponse = await saveApplicationNoValidation();
        if (!applicationResponse) return;

        const savedFormResponse = await applyApi.updateSharedForm(budget);
        if (savedFormResponse?.result) setSavedFormId(savedFormResponse.result);

        navigate('/home');
    };

    const onChangeAutofill = async () => {
        await validateAndSaveApplication();
        navigate(`/budget/selectbudget/${entryGuid}?pid=${propertyGuid}`);
    };

    const nextStepButton = {
        id: 'continueApplicationButton',
        dataTestid: 'continueApplicationButton',
        children: 'Continue',
        handleClick: onSaveAndContinue,
    };

    const saveAndExitButton = {
        id: 'saveAndExitApplicationButton',
        dataTestid: 'saveAndExitApplicationButton',
        children: 'Save and Exit',
        handleClick: onSaveAndExit,
    };

    const previousStepButtonClick = async (e: React.MouseEvent<Element, MouseEvent>) => {
        if (e) e.preventDefault();

        clearPausePoint();

        const applicationResponse = await saveApplicationNoValidation();
        if (!applicationResponse) return;
        navigateApplicationBackward();
    };

    return (
        <ValidationGroup
            ref={validationGroupRef}
            className={printMode ? 'print' : ''}
        >
            <ApplicationEntryLayout
                currentCrumb={ApplicationCrumbType.Budget}
                saveAndExitButtonProps={saveAndExitButton}
                nextStepButtonProps={nextStepButton}
                previousStepButtonVisible={true}
                previousStepButtonClick={previousStepButtonClick}
                propertyAddress={propertyName}
                printMode={printMode}
            >
                <div>
                    {!printMode && !newFixFlipBudgetSelected ? (
                        <Button
                            id='tertiaryBudgetButton'
                            theme={ButtonTheme.TertiaryBudget}
                            handleClick={onChangeAutofill}
                            children={
                                <div className='autofill'>
                                    Change autofill selection
                                    <img
                                        src='/assets/img/change-autofill.png'
                                        alt='Change Autofill Selection'
                                        height='100%'
                                    />
                                </div>
                            }
                        ></Button>
                    ) : (
                        <h1>Budget</h1>
                    )}
                    <div className='paired-fields-wrapper'>
                        <h4 className='headers'>Property Cost</h4>
                        <AcquisitionPrice
                            propertyGuid={propertyGuid}
                            isReview={printMode}
                        />
                        <InitialInspection
                            propertyGuid={propertyGuid}
                            isReview={printMode}
                        />
                        <span>
                            <PropertyCostOtherAmount
                                propertyGuid={propertyGuid}
                                isReview={printMode}
                            />
                            <PropertyCostOtherDescription
                                propertyGuid={propertyGuid}
                                isReview={printMode}
                            />
                        </span>
                    </div>
                    <div className='paired-fields-wrapper'>
                        <h4 className='headers'>Site Work</h4>
                        <span>
                            <Demolition
                                propertyGuid={propertyGuid}
                                isReview={printMode}
                            />
                            <DemolitionDescription
                                propertyGuid={propertyGuid}
                                isReview={printMode}
                            />
                        </span>
                        <span>
                            <BuildingPermitFees
                                propertyGuid={propertyGuid}
                                isReview={printMode}
                            />
                            <BuildingPermitFeesDescription
                                propertyGuid={propertyGuid}
                                isReview={printMode}
                            />
                        </span>
                        <span>
                            <ArchitectureEngineering
                                propertyGuid={propertyGuid}
                                isReview={printMode}
                            />
                            <ArchitectureEngineeringDescription
                                propertyGuid={propertyGuid}
                                isReview={printMode}
                            />
                        </span>
                        <span>
                            <SiteWorkFixFlipOtherAmount
                                propertyGuid={propertyGuid}
                                isReview={printMode}
                            />
                            <SiteWorkFixFlipOtherDescription
                                propertyGuid={propertyGuid}
                                isReview={printMode}
                            />
                        </span>
                    </div>
                    <div className='paired-fields-wrapper'>
                        <h4 className='headers'>Exterior Structure</h4>
                        <span>
                            <PaintingSidingWallFinish
                                propertyGuid={propertyGuid}
                                isReview={printMode}
                            />
                            <PaintingSidingWallFinishDescription
                                propertyGuid={propertyGuid}
                                isReview={printMode}
                            />
                        </span>
                        <span>
                            <GuttersOrFasciaDownspout
                                propertyGuid={propertyGuid}
                                isReview={printMode}
                            />
                            <GuttersFasciaDownspoutDescription
                                propertyGuid={propertyGuid}
                                isReview={printMode}
                            />
                        </span>
                        <span>
                            <PorchOrDeck
                                propertyGuid={propertyGuid}
                                isReview={printMode}
                            />
                            <PorchOrDeckDescription
                                propertyGuid={propertyGuid}
                                isReview={printMode}
                            />
                        </span>
                        <span>
                            <Roofing
                                propertyGuid={propertyGuid}
                                isReview={printMode}
                            />
                            <RoofingDescription
                                propertyGuid={propertyGuid}
                                isReview={printMode}
                            />
                        </span>
                        <span>
                            <WindowsAndDoors
                                propertyGuid={propertyGuid}
                                isReview={printMode}
                            />
                            <WindowsAndDoorsDescription
                                propertyGuid={propertyGuid}
                                isReview={printMode}
                            />
                        </span>
                        <span>
                            <GarageDoor
                                propertyGuid={propertyGuid}
                                isReview={printMode}
                            />
                            <GarageDoorDescription
                                propertyGuid={propertyGuid}
                                isReview={printMode}
                            />
                        </span>
                        <span>
                            <ExteriorStructureOtherAmount
                                propertyGuid={propertyGuid}
                                isReview={printMode}
                            />
                            <ExteriorStructureOtherDescription
                                propertyGuid={propertyGuid}
                                isReview={printMode}
                            />
                        </span>
                    </div>
                    <div className='paired-fields-wrapper'>
                        <h4 className='headers'>Major Systems</h4>
                        <span>
                            <Plumbing
                                propertyGuid={propertyGuid}
                                isReview={printMode}
                            />
                            <PlumbingDescription
                                propertyGuid={propertyGuid}
                                isReview={printMode}
                            />
                        </span>
                        <span>
                            <Electrical
                                propertyGuid={propertyGuid}
                                isReview={printMode}
                            />
                            <ElectricalDescription
                                propertyGuid={propertyGuid}
                                isReview={printMode}
                            />
                        </span>
                        <span>
                            <HVAC
                                propertyGuid={propertyGuid}
                                isReview={printMode}
                            />
                            <HVACDescription
                                propertyGuid={propertyGuid}
                                isReview={printMode}
                            />
                        </span>
                        <span>
                            <SewerOrSeptic
                                propertyGuid={propertyGuid}
                                isReview={printMode}
                            />
                            <SewerOrSepticDescription
                                propertyGuid={propertyGuid}
                                isReview={printMode}
                            />
                        </span>
                        <span>
                            <MajorSystemsOtherAmount
                                propertyGuid={propertyGuid}
                                isReview={printMode}
                            />
                            <MajorSystemsOtherDescription
                                propertyGuid={propertyGuid}
                                isReview={printMode}
                            />
                        </span>
                    </div>
                    <div className='paired-fields-wrapper'>
                        <h4 className='headers'>Interior</h4>
                        <span>
                            <Insulation
                                propertyGuid={propertyGuid}
                                isReview={printMode}
                            />
                            <InsulationDescription
                                propertyGuid={propertyGuid}
                                isReview={printMode}
                            />
                        </span>
                        <span>
                            <Drywall
                                propertyGuid={propertyGuid}
                                isReview={printMode}
                            />
                            <DrywallDescription
                                propertyGuid={propertyGuid}
                                isReview={printMode}
                            />
                        </span>
                        <span>
                            <InteriorTrimsDoorsAndMirrors
                                propertyGuid={propertyGuid}
                                isReview={printMode}
                            />
                            <InteriorTrimsDoorsAndMirrorsDescription
                                propertyGuid={propertyGuid}
                                isReview={printMode}
                            />
                        </span>
                        <span>
                            <Lighting
                                propertyGuid={propertyGuid}
                                isReview={printMode}
                            />
                            <LightingDescription
                                propertyGuid={propertyGuid}
                                isReview={printMode}
                            />
                        </span>
                        <span>
                            <CabinetsAndCountertops
                                propertyGuid={propertyGuid}
                                isReview={printMode}
                            />
                            <CabinetsAndCountertopsDescription
                                propertyGuid={propertyGuid}
                                isReview={printMode}
                            />
                        </span>
                        <span>
                            <Appliances
                                propertyGuid={propertyGuid}
                                isReview={printMode}
                            />
                            <AppliancesDescription
                                propertyGuid={propertyGuid}
                                isReview={printMode}
                            />
                        </span>
                        <span>
                            <Flooring
                                propertyGuid={propertyGuid}
                                isReview={printMode}
                            />
                            <FlooringDescription
                                propertyGuid={propertyGuid}
                                isReview={printMode}
                            />
                        </span>
                        <span>
                            <PlumbingFixtures
                                propertyGuid={propertyGuid}
                                isReview={printMode}
                            />
                            <PlumbingFixturesDescription
                                propertyGuid={propertyGuid}
                                isReview={printMode}
                            />
                        </span>
                        <span>
                            <Fireplace
                                propertyGuid={propertyGuid}
                                isReview={printMode}
                            />
                            <FireplaceDescription
                                propertyGuid={propertyGuid}
                                isReview={printMode}
                            />
                        </span>
                        <span>
                            <InteriorOtherAmount
                                propertyGuid={propertyGuid}
                                isReview={printMode}
                            />
                            <InteriorOtherDescription
                                propertyGuid={propertyGuid}
                                isReview={printMode}
                            />
                        </span>
                    </div>
                    <div className='paired-fields-wrapper'>
                        <h4 className='headers'>Expand Primary Structure</h4>
                        <span>
                            <Item1
                                propertyGuid={propertyGuid}
                                isReview={printMode}
                            />
                            <Item1Description
                                propertyGuid={propertyGuid}
                                isReview={printMode}
                            />
                        </span>
                        <span>
                            <Item2
                                propertyGuid={propertyGuid}
                                isReview={printMode}
                            />
                            <Item2Description
                                propertyGuid={propertyGuid}
                                isReview={printMode}
                            />
                        </span>
                        <span>
                            <Item3
                                propertyGuid={propertyGuid}
                                isReview={printMode}
                            />
                            <Item3Description
                                propertyGuid={propertyGuid}
                                isReview={printMode}
                            />
                        </span>
                        <span>
                            <Item4
                                propertyGuid={propertyGuid}
                                isReview={printMode}
                            />
                            <Item4Description
                                propertyGuid={propertyGuid}
                                isReview={printMode}
                            />
                        </span>
                        <span>
                            <Item5
                                propertyGuid={propertyGuid}
                                isReview={printMode}
                            />
                            <Item5Description
                                propertyGuid={propertyGuid}
                                isReview={printMode}
                            />
                        </span>
                    </div>
                    <div className='paired-fields-wrapper'>
                        <h4 className='headers'>Final Structure</h4>
                        <span>
                            <Landscaping
                                propertyGuid={propertyGuid}
                                isReview={printMode}
                            />
                            <LandscapingDescription
                                propertyGuid={propertyGuid}
                                isReview={printMode}
                            />
                        </span>
                        <span>
                            <OutdoorStructures
                                propertyGuid={propertyGuid}
                                isReview={printMode}
                            />
                            <OutdoorStructuresDescription
                                propertyGuid={propertyGuid}
                                isReview={printMode}
                            />
                        </span>
                        <span>
                            <DrivewayAndWalks
                                propertyGuid={propertyGuid}
                                isReview={printMode}
                            />
                            <DrivewayAndWalksDescription
                                propertyGuid={propertyGuid}
                                isReview={printMode}
                            />
                        </span>
                        <span>
                            <CleanUp
                                propertyGuid={propertyGuid}
                                isReview={printMode}
                            />
                            <CleanUpDescription
                                propertyGuid={propertyGuid}
                                isReview={printMode}
                            />
                        </span>
                        <span>
                            <FinalStructureOtherAmount
                                propertyGuid={propertyGuid}
                                isReview={printMode}
                            />
                            <FinalStructureOtherDescription
                                propertyGuid={propertyGuid}
                                isReview={printMode}
                            />
                        </span>
                    </div>
                    <BudgetTotal budget={budget} />
                </div>
                <DxTextBox
                    value=''
                    visible={false}
                >
                    <Validator validationGroup={BUDGET_GROUP}>
                        <CustomRule
                            reevaluate={true}
                            message='Total budget value too low, minimum total budget is $75,000'
                            validationCallback={() => sumBudgetNumbers(budget?.values ?? {}) >= 75000}
                        />
                    </Validator>
                </DxTextBox>
                <div className='validation-summary-center'>
                    <ValidationSummary validationGroup={BUDGET_GROUP} />
                </div>
            </ApplicationEntryLayout>
        </ValidationGroup>
    );
};
